export const SHOWCASE_DESIGN_CONTRACT_VERSION = "2" as const;

export const SHOWCASE_DESIGN_ROOT_ATTRIBUTE = "data-tp-showcase-root" as const;
export const SHOWCASE_DESIGN_ROOT_SELECTOR =
  `[${SHOWCASE_DESIGN_ROOT_ATTRIBUTE}]` as const;
export const SHOWCASE_DESIGN_STYLE_ATTRIBUTE = "data-tp-flow-design" as const;

export const SHOWCASE_DESIGN_PARTS = {
  title: "title",
  titlePrimary: "title-primary",
  titleAccent: "title-accent",
  titleAccentText: "title-accent-text",
  titleLock: "title-lock",
  progress: "progress",
  progressHint: "progress-hint",
  progressTrack: "progress-track",
  progressFill: "progress-fill",
  progressPercent: "progress-percent",
  error: "error",
  resourceEmpty: "resource-empty",
  resourceList: "resource-list",
  resourceItem: "resource-item",
  resourceCard: "resource-card",
  resourceOpen: "resource-open",
  resourceIcon: "resource-icon",
  resourceIconImage: "resource-icon-image",
  resourceCopy: "resource-copy",
  resourceTitle: "resource-title",
  resourceDescription: "resource-description",
  resourceCheck: "resource-check",
  resourceCheckIcon: "resource-check-icon",
  finalButton: "final-button",
  finalLock: "final-lock",
  finalText: "final-text",
} as const;

export const SHOWCASE_DESIGN_RESOURCE_TYPES = [
  "channel_public",
  "channel_private",
  "chat_public",
  "chat_private",
  "bot",
] as const;

export const SHOWCASE_DESIGN_VERIFICATION_MODES = [
  "verified",
  "no_check",
] as const;

export const SHOWCASE_DESIGN_RESOURCE_STATES = [
  "pending",
  "not_member",
  "error",
] as const;

export const SHOWCASE_DESIGN_RESOURCE_OWNERS = ["sponsor", "driver"] as const;
export const SHOWCASE_DESIGN_BOOLEAN_STATES = ["false", "true"] as const;
export const SHOWCASE_DESIGN_PROGRESS_STAGES = [
  "start",
  "middle",
  "final",
] as const;
export const SHOWCASE_DESIGN_CHECK_ACTIONS = [
  "verify-membership",
  "open-and-complete",
] as const;

export type ShowcaseDesignPart =
  (typeof SHOWCASE_DESIGN_PARTS)[keyof typeof SHOWCASE_DESIGN_PARTS];
export type ShowcaseDesignResourceType =
  (typeof SHOWCASE_DESIGN_RESOURCE_TYPES)[number];
export type ShowcaseDesignVerificationMode =
  (typeof SHOWCASE_DESIGN_VERIFICATION_MODES)[number];
export type ShowcaseDesignResourceState =
  (typeof SHOWCASE_DESIGN_RESOURCE_STATES)[number];
export type ShowcaseDesignResourceOwner =
  (typeof SHOWCASE_DESIGN_RESOURCE_OWNERS)[number];
export type ShowcaseDesignBooleanState =
  (typeof SHOWCASE_DESIGN_BOOLEAN_STATES)[number];
export type ShowcaseDesignProgressStage =
  (typeof SHOWCASE_DESIGN_PROGRESS_STAGES)[number];
export type ShowcaseDesignCheckAction =
  (typeof SHOWCASE_DESIGN_CHECK_ACTIONS)[number];

export function toShowcaseDesignBooleanState(
  value: boolean,
): ShowcaseDesignBooleanState {
  return value ? "true" : "false";
}

export function showcaseDesignResourceOwner(
  isDriverOwn: boolean | undefined,
): ShowcaseDesignResourceOwner {
  return isDriverOwn ? "driver" : "sponsor";
}
